import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from '../static/styles/CannonClashInstructions.module.css';

const AimTrainInstructions = ({ isOpen, onClose }) => {
    const navigate = useNavigate();

    if (!isOpen) return null;

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const slides = [
        {
            title: 'How to Join',
            content: (
                <div className={styles.rulesContainer}>
                    <div className={styles.rule}>Click "Join Now" to register for the tournament</div>
                    <div className={styles.rule}>Receive SMS with Room ID and Match Time one hour before start</div>
                    <div className={styles.rule}>At match time, click "Play Now" and enter your Room ID</div>
                </div>
            )
        },
        {
            title: 'Game Controls',
            content: (
                <div className={styles.rulesContainer}>
                    <div className={styles.rule}>Desktop: Use mouse to aim and click to shoot</div>
                    <div className={styles.rule}>Mobile: Touch to aim and tap to shoot</div>
                    <div className={styles.rule}>Game automatically connects you to multiplayer match</div>
                </div>
            )
        },
        {
            title: 'Objective',
            content: (
                <div className={styles.rulesContainer}>
                    <div className={styles.rule}>Eliminate opponent in 1v1 battle</div>
                    <div className={styles.rule}>Proceed to next round after winning</div>
                    <div className={styles.rule}>Survive to final round to earn credits</div>
                </div>
            )
        },
        {
            title: 'Tournament Rules',
            content: (
                <div className={styles.rulesContainer}>
                    <div className={styles.rule}>Progressive multiplayer tournament format</div>
                    <div className={styles.rule}>No-show = elimination from tournament</div>
                    <div className={styles.rule}>Top performers advance to next rounds</div>
                    <div className={styles.rule}>Rewards credited instantly to wallet</div>
                </div>
            )
        }
    ];

    return (
        <div className={styles.overlay} onClick={handleOverlayClick}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <h2>How to Play</h2>
                </div>

                <div className={styles.popup}>
                    <button className={styles.closeButton} onClick={onClose}>×</button>

                    <Swiper
                        modules={[Pagination]}
                        pagination={{
                            clickable: true
                        }}
                        spaceBetween={0}
                        slidesPerView={1}
                        className={styles.swiper}
                        loop
                    >
                        {slides.map((slide, index) => (
                            <SwiperSlide key={index}>
                                <div className={styles.content}>
                                    <div className={styles.roundHeader}>
                                        <h2>{slide.title}</h2>
                                    </div>
                                    {slide.content}
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
};

export default AimTrainInstructions;